import type {IIdSelection} from '@netx/core-next/types';
import type {CustomVirtualizedSelection} from '../types';

export const parseCustomVirtualizedSelectionToRowSelection = (
	rowSelection: CustomVirtualizedSelection,
): IIdSelection<number> => {
	const {includeIds, excludeIds, ...rest} = rowSelection;
	return {
		...rest,
		includeIds: includeIds.map((id) => parseInt(id, 10)),
		excludeIds: excludeIds.map((id) => parseInt(id, 10)),
	};
};
